import React, { useState } from 'react';
import paymentQR from '../../assets/payment-qr.png';

var COMPANY_UPI_ID      = 'info.protowiz@oksbi';
var COMPANY_NAME        = 'Ibots in';
var COMPANY_UPI_DISPLAY = 'info.protowiz@oksbi';

export default function PaymentModal({ r, onClose, onConfirm, paying }) {
  var [step, setStep] = useState('qr');
  var [utr,  setUtr]  = useState('');
  var [err,  setErr]  = useState('');
  var [copied, setCopied] = useState(false);

  var courseName = r.course || r.formType || 'Programme';

  function handleCopy() {
    navigator.clipboard.writeText(COMPANY_UPI_DISPLAY);
    setCopied(true);
    setTimeout(function(){ setCopied(false); }, 2000);
  }

  function handleConfirm() {
    if (!utr.trim()) { setErr('Please enter the UTR / Transaction ID from your UPI app.'); return; }
    if (utr.trim().length < 6) { setErr('Please enter a valid UTR number.'); return; }
    onConfirm(r.eid, utr.trim());
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(5,15,40,0.75)', backdropFilter:'blur(8px)', zIndex:99999, display:'flex', alignItems:'center', justifyContent:'center', padding:16, fontFamily:"'Nunito','Segoe UI',sans-serif" }}
      onClick={function(e){ e.target===e.currentTarget && onClose(); }}>
      <div style={{ background:'#fff', borderRadius:20, width:'100%', maxWidth:400, overflow:'hidden', boxShadow:'0 32px 80px rgba(5,15,50,0.35)' }}>

        {/* Header */}
        <div style={{ background:'linear-gradient(135deg,#0d2e6e,#2563eb)', padding:'18px 22px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ fontSize:15, fontWeight:900, color:'#fff', marginBottom:2 }}>Pay & Enrol</div>
            <div style={{ fontSize:11.5, color:'rgba(255,255,255,0.7)' }}>{courseName} · {r.eid}</div>
          </div>
          <button onClick={onClose} style={{ width:28, height:28, borderRadius:'50%', border:'1.5px solid rgba(255,255,255,0.3)', background:'rgba(255,255,255,0.1)', color:'#fff', fontSize:13, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>✕</button>
        </div>

        {/* Step indicators */}
        <div style={{ display:'flex', borderBottom:'1px solid #f1f5f9' }}>
          {[['qr','1. Scan & Pay'],['ref','2. Enter UTR']].map(function(s) {
            var isActive = step === s[0];
            return (
              <div key={s[0]} style={{ flex:1, padding:'10px', textAlign:'center', fontSize:12, fontWeight:700,
                color: isActive ? '#2563eb' : '#94a3b8',
                borderBottom: isActive ? '2px solid #2563eb' : '2px solid transparent',
                background: isActive ? '#f8faff' : '#fff' }}>
                {s[1]}
              </div>
            );
          })}
        </div>

        {/* QR Step */}
        {step === 'qr' && (
          <div style={{ padding:'20px', textAlign:'center' }}>
            <div style={{ fontSize:12.5, color:'#64748b', marginBottom:14, lineHeight:1.6 }}>
              Scan the QR code below using any UPI app to pay for your course registration.
            </div>

            {/* QR Image */}
            <div style={{ margin:'0 auto 14px', width:240, height:240, background:'#fff', border:'1.5px solid #e2e8f0', borderRadius:14, display:'flex', alignItems:'center', justifyContent:'center', padding:10, boxShadow:'0 2px 12px rgba(15,23,42,0.08)' }}>
              <img src={paymentQR} alt="UPI QR Code" style={{ width:'100%', height:'100%', objectFit:'contain', borderRadius:8 }} />
            </div>

            {/* Company name */}
            <div style={{ fontSize:13, fontWeight:800, color:'#0d2e6e', marginBottom:10 }}>{COMPANY_NAME}</div>

            {/* UPI ID */}
            <div style={{ background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, padding:'10px 14px', marginBottom:14, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
              <div style={{ textAlign:'left' }}>
                <div style={{ fontSize:10, fontWeight:700, color:'#94a3b8', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:2 }}>UPI ID</div>
                <div style={{ fontSize:13.5, fontWeight:800, color:'#0d2e6e' }}>{COMPANY_UPI_DISPLAY}</div>
              </div>
              <button onClick={handleCopy}
                style={{ padding:'5px 12px', background: copied ? '#dcfce7' : '#eff6ff', border:'1px solid ' + (copied ? '#bbf7d0' : '#bfdbfe'), borderRadius:7, color: copied ? '#166534' : '#2563eb', fontSize:12, fontWeight:700, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
                {copied ? '✓ Copied' : 'Copy'}
              </button>
            </div>

            {/* Steps */}
            <div style={{ background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, padding:'12px 14px', marginBottom:18, textAlign:'left' }}>
              <div style={{ fontSize:11.5, fontWeight:700, color:'#475569', marginBottom:6 }}>Steps to pay:</div>
              {['Open PhonePe / GPay / Paytm', 'Scan QR or enter UPI ID manually', 'Complete the payment', 'Note down Transaction ID (UTR)'].map(function(s, i) {
                return (
                  <div key={i} style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}>
                    <div style={{ width:18, height:18, borderRadius:'50%', background:'#eff6ff', color:'#2563eb', fontSize:10, fontWeight:800, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{i+1}</div>
                    <span style={{ fontSize:12, color:'#475569' }}>{s}</span>
                  </div>
                );
              })}
            </div>

            <button onClick={function(){ setStep('ref'); }}
              style={{ width:'100%', padding:'13px', background:'linear-gradient(135deg,#0d2e6e,#2563eb)', border:'none', borderRadius:10, color:'#fff', fontSize:14, fontWeight:800, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
              I Have Paid — Enter UTR →
            </button>
          </div>
        )}

        {/* UTR Step */}
        {step === 'ref' && (
          <div style={{ padding:'20px' }}>
            <div style={{ fontSize:13.5, fontWeight:900, color:'#0d2e6e', marginBottom:6 }}>Enter Transaction ID</div>
            <div style={{ fontSize:12.5, color:'#64748b', marginBottom:18, lineHeight:1.6 }}>
              Enter the UTR / Transaction Reference ID from your UPI app after completing payment for <strong>{courseName}</strong>.
            </div>

            <label style={{ fontSize:11, fontWeight:700, color:'#475569', textTransform:'uppercase', letterSpacing:'0.5px', display:'block', marginBottom:6 }}>
              UTR / Transaction Reference ID *
            </label>
            <input type="text" value={utr} onChange={function(e){ setUtr(e.target.value); setErr(''); }}
              placeholder="e.g. 407812345678"
              style={{ width:'100%', padding:'12px 14px', border:'1.5px solid ' + (err ? '#fca5a5' : '#e2e8f0'), borderRadius:10, fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:"'Nunito','Segoe UI',sans-serif", marginBottom:6 }} />
            {err && <div style={{ fontSize:12, color:'#dc2626', marginBottom:8, display:'flex', alignItems:'center', gap:5 }}>⚠ {err}</div>}

            <div style={{ fontSize:12, color:'#94a3b8', marginBottom:20, background:'#f8fafc', borderRadius:8, padding:'8px 12px', lineHeight:1.6 }}>
              <strong>Where to find UTR:</strong> UPI App → Transactions → select this payment → copy the 12-digit reference number
            </div>

            <div style={{ background:'#fffbeb', border:'1px solid #fde68a', borderRadius:10, padding:'10px 12px', marginBottom:18, fontSize:12, color:'#92400e', lineHeight:1.6 }}>
              ⏳ Your payment will be verified by the iBots team within 24 hours. Course materials will unlock once verified.
            </div>

            <div style={{ display:'flex', gap:10 }}>
              <button onClick={function(){ setStep('qr'); setErr(''); }}
                style={{ flex:1, padding:'12px', background:'#f1f5f9', border:'none', borderRadius:10, color:'#475569', fontSize:13, fontWeight:700, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif" }}>
                ← Back
              </button>
              <button onClick={handleConfirm} disabled={paying===r.eid}
                style={{ flex:2, padding:'12px', background:'linear-gradient(135deg,#166534,#22c55e)', border:'none', borderRadius:10, color:'#fff', fontSize:13, fontWeight:800, cursor:'pointer', fontFamily:"'Nunito','Segoe UI',sans-serif", opacity:paying===r.eid?0.7:1 }}>
                {paying===r.eid ? 'Submitting...' : 'Submit Payment ✓'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
